import { getConfig, init } from './lib/envs.esm.js';

var index = {
    init: init,
    getConfig: getConfig
};

export { index as default };
